import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form as AntdForm } from 'antd';
import { useNavigate } from 'react-router-dom';
import Form from '../../../../antd/form/Form/Form.jsx';
import FormRadioGroup from '../../../../antd/form/FormRadioGroup/FormRadioGroup.jsx';
import FormSelect from '../../../../antd/form/FormSelect/FormSelect.jsx';
import FormNumberField from '../../../../antd/form/FormNumberField/FormNumberField.jsx';
import FormTextArea from '../../../../antd/form/FormTextArea/FormTextArea.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import CollapseBlock from '../../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import { required } from '../../../../antd/form/FormValidation.js';

const IpPanelStoryForm = ({
  onSubmit,
  initials,
  form,
  disabled,
  hasYear1Students = true,
  hasYear2Students = true,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const year1 = AntdForm.useWatch('year1_action', form);
  const year2 = AntdForm.useWatch('year2_action', form);
  const showPsRequirements = year1 === 'ps' || year2 === 'ps';

  const actionOptions = [
    { label: t('Panel Story (konferenčný spôsob/prezentácia)'), value: 'ps' },
    { label: t('Katedrová prezentácia'), value: 'kp' },
    { label: t('Na projekte nie sú študenti tohto ročníka'), value: 'ns' },
    { label: t('Študenti sa nezúčastnia z iného dôvodu (potrebné uviesť nižšie)'), value: 'id' },
  ];

  const sectionOptions = [
    { label: t('Sekcia IS, IIS, BI - miestnosti RC009, RC007, RC006'), value: 'is' },
    { label: t('Sekcia IM - miestnosť RA003 (Informačné centrum)'), value: 'im' },
    { label: t('Sekcia ASI - miestnosť RC001'), value: 'asi' },
    { label: t('Sekcia PI - miestnosť RB108 (Projekt 3), RB103 (Projekt 1)'), value: 'pi' },
  ];

  return (
    <Form form={form} onFinish={onSubmit} initialValues={initials}>
      <CollapseBlock title={t('Spôsob prezentácie výsledkov projektu')}>
        <FormRadioGroup
          label={t('Študenti prvého ročníka sa zúčastnia akcie:')}
          name="year1_action"
          options={actionOptions}
          rules={[required(t)]}
          disabled={disabled || !hasYear1Students}
          help={!hasYear1Students ? t('Na projekte nie sú študenti prvého ročníka.') : undefined}
        />
        <FormRadioGroup
          label={t('Študenti druhého ročníka sa zúčastnia akcie:')}
          name="year2_action"
          options={actionOptions}
          rules={[required(t)]}
          disabled={disabled || !hasYear2Students}
          help={!hasYear2Students ? t('Na projekte nie sú študenti druhého ročníka.') : undefined}
        />
        <FormTextArea
          label={t('Dôvody neúčasti:')}
          name="excused"
          disabled={disabled}
          help={t('Ak sa nejaký študent nezúčastní žiadnej z akcií, treba uviesť meno a dôvod. Napr. nepracoval na projekte, zdravotné dôvody, Erazmus pobyt a pod.')}
        />
      </CollapseBlock>

      {showPsRequirements && (
        <CollapseBlock title={t('Požiadavky na Panel Story')}>
          <FormSelect
            label={t('Sekcia:')}
            name="section"
            options={sectionOptions}
            rules={[required(t)]}
            disabled={disabled}
          />
          <FormNumberField
            label={t('Počet stolov:')}
            name="tables_count"
            min={0}
            disabled={disabled}
          />
          <FormNumberField
            label={t('Počet stoličiek:')}
            name="chairs_count"
            min={0}
            disabled={disabled}
          />
          <FormTextArea
            label={t('Ďalšie požiadavky:')}
            name="other_requirements"
            disabled={disabled}
          />
        </CollapseBlock>
      )}

      <CollapseBlock title={t('Zmeny v projekte Ing. štúdia')}>
        <FormTextArea
          label={t('Zoznam zmien:')}
          name="changes"
          disabled={disabled}
          help={t('Ak sa zmenil počet študentov na projekte, je potrebné vypísať všetky zmeny (študenti, ktorí už nepracujú na projekte a noví študenti)')}
        />
      </CollapseBlock>

      {!disabled && (
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey="panel-story">
            {t('Uložiť')}
          </FormButton>
          <FormButton onClick={() => navigate(-1)}>
            {t('Zrušiť')}
          </FormButton>
        </FormButtonsContainer>
      )}
    </Form>
  );
};

IpPanelStoryForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initials: PropTypes.object,
  form: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  hasYear1Students: PropTypes.bool,
  hasYear2Students: PropTypes.bool,
};

export default IpPanelStoryForm;
